// React
import React, { FC } from 'react';

// Material
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { SxProps } from '@mui/material/styles';

// Types
import { MenuItems } from 'utils/types';

// Type
type SelectBaseProps = {
  value: any;
  menuItems?: MenuItems<any>;
  sx?: SxProps;
  sxSelect?: SxProps;
  sxSelectItem?: SxProps;
  disable?: boolean;
  onChange: (_event: any) => void;
  onItemClick?: () => void;
};

// Base Component
const SelectBase: FC<SelectBaseProps> = ({
  value,
  menuItems,
  sx,
  sxSelect,
  sxSelectItem,
  disable = false,
  onChange,
  onItemClick,
}) => {
  return (
    <Box sx={sx}>
      <FormControl fullWidth variant="outlined">
        <Select disabled={disable} value={value} onChange={onChange} displayEmpty sx={sxSelect}>
          {menuItems?.map((item, index) => (
            <MenuItem
              sx={sxSelectItem}
              key={index}
              value={item.value}
              onClick={onItemClick}
              disabled={item.disable}
            >
              {item.content}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectBase;
